import { DefaultAPIInstance } from "@/api";

const detail_url = 'users/detail-telephone/';
const detail_internet_url = 'users/detail-internet/';

export const DetailingAPI = {
    sendRequest(userId, userInfo) {
        return DefaultAPIInstance.post(`${detail_url}${userId}/`, userInfo)
    },
    sendInternetRequest(userId, userInfo) {
        return DefaultAPIInstance.get(`${detail_internet_url}${userId}/`, {params: userInfo})
    },
}
